export default {
    path: 'all_menu_setting',
    name: 'AllMenuSetting',
    component: () => import(/* webpackChunkName: "all-menu-setting" */ '@/pages/menu/AllMenuSetting'),
    meta: { title: '全部菜单设置' }
}
